// separator.styled.ts
import styled from 'styled-components';
import { colors, spacings } from '@styles/DesignVariables';

interface SeparatorProps {
	$height: string;
	$color?: string;
	$spacing?: string;
}

interface HorizontalSeparatorProps {
	$width: string;
	$color?: string;
	$spacing?: string;
}

export const Separator = styled.div<SeparatorProps>`
	width: 1px;
	height: ${({ $height }) => $height};
	background-color: ${({ $color }) => $color || colors.grey800};
	margin: 0 ${({ $spacing }) => $spacing || spacings.s16};
`;

export const HortizontalSeparator = styled.div<HorizontalSeparatorProps>`
	height: 1px;
	width: ${({ $width }) => $width};
	background-color: ${({ $color }) => $color || colors.grey800};
	margin: ${({ $spacing }) => $spacing || spacings.s16} 0;
`;
